import {
  EAdminPortalClientPath,
  EClientPath,
  EMarketingClientPath,
} from '~/models/api'

export type TAppNavItem = {
  name: string
  path?: EClientPath | EMarketingClientPath | EAdminPortalClientPath
  children?: TAppNavItem[]
}
const navItems: TAppNavItem[] = [
  {
    name: 'Home',
    path: EMarketingClientPath.home,
  },
  {
    name: 'About',
    path: EMarketingClientPath.about,
  },
  {
    name: 'Who We Help',
    children: [
      {
        name: 'Gyms & Fitness Studios',
        path: EMarketingClientPath.whoWeHelpGym,
      },
      {
        name: 'Spas & Wellness Centers',
        path: EMarketingClientPath.whoWeHelpSpas,
      },
      {
        name: 'Recreation & Sports Facilities',
        path: EMarketingClientPath.whoWeHelpRecreationFacilities,
      },
      {
        name: 'Small & Medium Businesses',
        path: EMarketingClientPath.whoWeHelpOther,
      },
      // {
      //   name: 'Martial Arts, Dance, & Movement',
      //   path: EMarketingClientPath.whoWeHelpMartialArtsDanceMovement,
      // },
      {
        name: 'White-Label Partners',
        path: EMarketingClientPath.whoWeHelpWhiteLabel,
      },
    ],
  },
  {
    name: 'Pricing',
    path: EMarketingClientPath.pricing,
  },
  {
    name: 'Help',
    children: [
      {
        name: 'FAQ',
        path: EMarketingClientPath.faq,
      },
      {
        name: 'Support',
        path: EMarketingClientPath.supportAndContact,
      },
    ],
  },
  {
    name: 'White Label',
    path: EMarketingClientPath.whiteLabel,
  },
]
export default navItems
